import swal from 'sweetalert2'

jQuery(document).ready(function ($) {
  $(document).on('click', '.btn-click-whatsapp', function (event) {
    const buttonEl = $(this)
    buttonEl.attr('disabled', true)

    const nomeInput = $('.contato-form #nome')
    const emailInput = $('.contato-form #email')
    const telefoneInput = $('.contato-form #telefone')

    const html = $(this).html()
    const thisButton = $(this)

    let hasError = 0

    if (window.isListagemModalEntrarContatoAberto && !$('.contato-wrapper').hasClass('authenticated')) {
      $('.contato-form')
        .find('.campo-validacao-obrigatorio')
        .each(function (index, el) {
          if ($(el).val() == '' && !$(el).hasClass('campo-mensagem')) {
            $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
            hasError = 1
          }
        })
    }

    if (hasError) {
      $(this).find('.contato-form-wrapper').stop().shake(100, 5)
      return false
    }

    $.post(this.getAttribute('data-url'), {
      _token: this.getAttribute('data-token'),
      nome: nomeInput.val(),
      email: emailInput.val(),
      telefone: telefoneInput.val(),
      isSecondTry: false
    }).done(function (data) {
      if (data == null || data == '') {
        grecaptcha.reset()
        return swal({
          title: 'Erro',
          text: 'Ocorreu algum problema ao buscar número do anunciante.',
          type: 'error'
        })
      }

      if (data.status === 'success') {
        grecaptcha.reset()
        buttonEl.attr('disabled', false)
        buttonEl.css('cursor', 'pointer')

        const whatsappLink = $('#whatsapp-link').attr('data-url')

        const anchor = document.createElement('a')
        anchor.href = whatsappLink
        anchor.target = '_blank'
        document.body.appendChild(anchor)
        anchor.click()
        return null
      }

      $('#modal .modal-data').html(data)
      $('#modal').show()
      buttonEl.attr('disabled', false)
      buttonEl.css('cursor', 'pointer')

      if (thisButton.hasClass('detail-mobile')) {
        $('#modal .modal-fechar').addClass('fechar-modal-whatsapp')
        $('#modal #whatsapp-contact-form .detail-mobile-whats').show()
        $('#modal #whatsapp-contact-form .normal-whats').hide()
      } else {
        $('#modal #whatsapp-contact-form .detail-mobile-whats').hide()
        $('#modal #whatsapp-contact-form .normal-whats').show()
      }

      $('#modal .modal-data input[data-mask]').each(function (index, el) {
        $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
      })

      var SPMaskBehavior = function (val) {
          return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'
        },
        spOptions = {
          onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options)
          }
        }

      $('#modal .modal-data input[data-maskphone]').each(function (index, el) {
        $(el).mask(SPMaskBehavior, spOptions)
      })
      $(event.currentTarget).html(html)
    })
    // if (ga) ga('send', 'pageview', window.location.pathname+'/whatsapp-clique');
    // if (ga) ga('send', 'event', 'Whatsapp');
    if (fbq) fbq('track', 'Lead')
  })

  $(document).on('click', '#see-phone-form button[type=submit]', function (event) {
    const contatoOcultoEl = $('.contato-oculto')
    const nomeInput = $('#see-phone-form #nome')
    const emailInput = $('#see-phone-form #email')
    const telefoneInput = $('#see-phone-form #telefone')

    const sendMessageForm = $('#send-message-form')

    let hasError = 0

    $('#see-phone-form')
      .find('.campo-validacao-obrigatorio')
      .each(function (index, el) {
        if ($(el).val() == '' && !$(el).hasClass('campo-mensagem')) {
          $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
          hasError = 1
        }
      })

    if (hasError) {
      $(this).find('.contato-form-wrapper').stop().shake(100, 5)
      return false
    }

    $(this).attr('disabled', true)

    $.post($('#see-phone-form').attr('data-url'), {
      _token: $('#see-phone-form').attr('data-token'),
      nome: nomeInput.val(),
      email: emailInput.val(),
      telefone: telefoneInput.val(),
      isSecondTry: true
    }).done(function (data) {
      sendMessageForm.find('#nome').val(nomeInput.val())
      sendMessageForm.find('#email').val(emailInput.val())
      sendMessageForm.find('#telefone').val(telefoneInput.val())

      $('#modal .modal-fechar').trigger('click')

      if (data?.status !== 'success') {
        return swal({
          title: 'Erro',
          text: 'Ocorreu algum problema ao buscar número do anunciante.',
          type: 'error'
        })
      }

      $('#send-message-form #nome').parent().addClass('active')
      $('#send-message-form #email').parent().addClass('active')
      $('#send-message-form #telefone').parent().addClass('active')

      contatoOcultoEl.hide()
      contatoOcultoEl.parent().find('.contato-aberto').show()
    })
  })

  $(document).on('click', '#whatsapp-contact-form button[type=submit]', function (event) {
    const nomeInput = $('#whatsapp-contact-form #nome')
    const emailInput = $('#whatsapp-contact-form #email')
    const telefoneInput = $('#whatsapp-contact-form #telefone')

    const sendMessageForm = $('#send-message-form')

    let hasError = 0

    $('#whatsapp-contact-form')
      .find('.campo-validacao-obrigatorio')
      .each(function (index, el) {
        if ($(el).val() == '' && !$(el).hasClass('campo-mensagem')) {
          $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
          hasError = 1
        }
      })

    if (hasError) {
      $(this).find('.contato-form-wrapper').stop().shake(100, 5)
      return false
    }

    $(this).attr('disabled', true)

    $.post($('#whatsapp-contact-form').attr('data-url'), {
      _token: $('#whatsapp-contact-form').attr('data-token'),
      nome: nomeInput.val(),
      email: emailInput.val(),
      telefone: telefoneInput.val(),
      isSecondTry: true
    }).done(function (data) {
      sendMessageForm.find('#nome').val(nomeInput.val())
      sendMessageForm.find('#email').val(emailInput.val())
      sendMessageForm.find('#telefone').val(telefoneInput.val())

      $('#modal .modal-fechar').trigger('click')

      if (data?.status !== 'success') {
        return swal({
          title: 'Erro',
          text: 'Ocorreu algum problema ao buscar número do anunciante.',
          type: 'error'
        })
      }

      $('#send-message-form #nome').parent().addClass('active')
      $('#send-message-form #email').parent().addClass('active')
      $('#send-message-form #telefone').parent().addClass('active')

      const buttonEl = $('.btn-click-whatsapp')
      buttonEl.attr('disabled', false)
      buttonEl.css('cursor', 'pointer')

      const whatsappLink = $('#form-whatsapp-link').attr('data-url')

      console.log($('#modal .modal-fechar'))

      if ($('#modal .modal-fechar').hasClass('fechar-modal-whatsapp')) {
        $('.visualizar-sidebar .modal-geral-fechar').trigger('click')
      }

      const anchor = document.createElement('a')
      anchor.href = whatsappLink
      anchor.target = '_blank'
      document.body.appendChild(anchor)
      anchor.click()
    })
  })

  $(document).on('click', '.contato-oculto', function (event) {
    const contatoOcultoEl = $(this)
    const nomeInput = $('.contato-form #nome')
    const emailInput = $('.contato-form #email')
    const telefoneInput = $('.contato-form #telefone')
    const recaptchaInput = $('#g-recaptcha-response')

    const html = $(this).html()
    const thisButton = $(this)
    let hasError = 0

    if (window.isListagemModalEntrarContatoAberto && !$('.contato-wrapper').hasClass('authenticated')) {
      $('.contato-form')
        .find('.campo-validacao-obrigatorio')
        .each(function (index, el) {
          if ($(el).val() == '' && !$(el).hasClass('campo-mensagem')) {
            $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
            hasError = 1
          }
        })
    }

    if (hasError) {
      $(this).find('.contato-form-wrapper').stop().shake(100, 5)
      return false
    }

    contatoOcultoEl.find('.see-phone-loader').show()
    contatoOcultoEl.find('.contato-telefone').hide()

    if ($(this).hasClass('detail-mobile')) {
      $('.visualizar-sidebar .contato-telefone-wrapper .contato-oculto').find('.see-phone-loader').show()
      $('.visualizar-sidebar .contato-telefone-wrapper .contato-oculto').find('.contato-telefone').hide()
    }

    $.post(this.getAttribute('data-url'), {
      _token: this.getAttribute('data-token'),
      nome: nomeInput.val(),
      email: emailInput.val(),
      telefone: telefoneInput.val(),
      isSecondTry: false,
      'g-recaptcha-response': recaptchaInput.val()
    }).done(function (data) {
      if (data == null || data == '') {
        grecaptcha.reset()
        return null
      }

      if (data.status === 'success') {
        grecaptcha.reset()
        contatoOcultoEl.hide()
        contatoOcultoEl.parent().find('.contato-aberto').show()

        if (thisButton.hasClass('detail-mobile')) {
          $('.visualizar-sidebar .contato-telefone-wrapper .contato-oculto').find('.see-phone-loader').hide()
          $('.visualizar-sidebar .contato-telefone-wrapper .contato-oculto').find('.contato-aberto').show()
        }

        return null
      }

      if (data.status === 'error') {
        grecaptcha.reset()
        contatoOcultoEl.find('.see-phone-loader').hide()
        contatoOcultoEl.find('.contato-telefone').show()
        return swal({
          title: 'Erro',
          text: data.message,
          type: 'error'
        })
      }

      $('#modal .modal-data').html(data)
      $('#modal').show()

      contatoOcultoEl.find('.see-phone-loader').hide()
      contatoOcultoEl.find('.contato-telefone').show()

      $('#modal .modal-data input[data-mask]').each(function (index, el) {
        $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
      })

      var SPMaskBehavior = function (val) {
          return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'
        },
        spOptions = {
          onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options)
          }
        }

      $('#modal .modal-data input[data-maskphone]').each(function (index, el) {
        $(el).mask(SPMaskBehavior, spOptions)
      })

      $(event.currentTarget).html(html)
    })

    // if (ga) ga('send', 'pageview', window.location.pathname+'/telefone-visualizado');
    if (fbq) fbq('track', 'Lead')
    $('#remarketing').html(
      '<div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/1066987287/?label=7zKeCLGry14Ql97j_AM&amp;guid=ON&amp;script=0"/></div>'
    )
  })

  $('.btn-wrapper-header-mobile .btn').click(function (event) {
    $('html,body').stop().animate({ scrollTop: 0 }, 300)

    if ($(this).hasClass('btn-show-contato')) {
      $('.visualizar-sidebar .contato-telefone-wrapper').hide()
      $('.visualizar-sidebar .contato-form').show()
      $('.visualizar-sidebar').show()
    } else if ($(this).hasClass('btn-show-telefone')) {
      $('.visualizar-sidebar .contato-telefone-wrapper').find('.contato-oculto').show()
      $('.visualizar-sidebar .contato-telefone-wrapper').show().find('.contato-oculto').trigger('click')
      $('.visualizar-sidebar .contato-form').hide()
      $('.visualizar-sidebar .contato-telefone-wrapper').find('.btn-click-whatsapp').hide()
      $('.visualizar-sidebar').show()
    } else if ($(this).hasClass('btn-click-whatsapp')) {
      // $('.visualizar-sidebar .contato-telefone-wrapper').show().find('.btn-click-whatsapp').trigger('click');
      $('.visualizar-sidebar .contato-form').hide()
      $('.visualizar-sidebar .contato-telefone-wrapper .contato-oculto').hide()
      // $('.visualizar-sidebar').show()
    }
  })

  $(document).on('mouseover', '.campo-default', function () {
    $(this).find('.campo-alerta').fadeOut(300)
  })

  $('.visualizar-endereco').click(function (event) {
    // if (ga) ga('send', 'event', 'VisualizarEndereco');
    $('.visualizar-endereco iframe').css({ cursor: 'default', 'pointer-events': 'auto' })
  })

  $('.visualizar-galeria-expandir').click(function (event) {
    // if (ga) ga('send', 'event', 'OpenModalFotos');

    if (!$(this).hasClass('loaded')) {
      $(this).addClass('loaded')

      var imagens = $('.visualizar-galeria-modal .galeria').attr('data-images')
      $('.visualizar-galeria-modal .galeria').attr('data-images', '')
      var baseUrl =
        $(window).width() > 780
          ? $('.visualizar-galeria-modal .galeria').attr('data-replace')
          : $('.visualizar-galeria-modal .galeria').attr('data-replaceMobile')
      imagens = imagens.split(',')

      if ($(window).width() > 1200) {
        var height = ($(window).height() > 1260 ? 1260 : $(window).height()) - 100
        var width = ($(window).width() > 1500 ? 1300 : $(window).width()) - 100
        var formularioW = 360
      } else if ($(window).width() > 980) {
        var height = ($(window).height() > 1260 ? 1260 : $(window).height()) - 100
        var width = ($(window).width() > 1500 ? 1300 : $(window).width()) - 100
        var formularioW = 0
        $('.visualizar-galeria-modal .formulario').remove()
      } else {
        var height = $(window).height()
        var width = $(window).width()
        var formularioW = 0
        $('.visualizar-galeria-modal .formulario').remove()
      }
      $('.visualizar-galeria-modal .data').css({
        width: width,
        marginLeft: (width / 2) * -1,
        height: height + 'px',
        lineHeight: height + 'px'
      })
      $('.visualizar-galeria-modal .fotos').css({ lineHeight: height + 'px', height: height + 'px', width: width - formularioW })
      $('.visualizar-galeria-modal .galeria').css({ lineHeight: height + 'px', height: height + 'px', width: width - formularioW })
      if ($('.visualizar-galeria-modal .formulario')[0]) $('.visualizar-galeria-modal .formulario').css({ lineHeight: height + 'px' })

      imagens.forEach(function (item) {
        var img = $('<img />')
        img.attr('src', baseUrl.replace('IMAGEMAQUI', item))
        img.css({ maxHeight: height - 4 + 'px', maxWidth: width - formularioW - 4 + 'px' })
        $('.visualizar-galeria-modal .galeria').append(img)
      })

      $('.visualizar-galeria-modal .galeria')
        .addClass('owl-carousel')
        .owlCarousel({
          items: 1,
          lazyLoad: true,
          loop: true,
          dots: false,
          nav: true,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
        })
      $('.visualizar-galeria-modal .owl-item').css({ lineHeight: height + 'px', height: height + 'px' })
      // $('.visualizar-galeria-modal .owl-stage-outer').css({ lineHeight: height+'px' });
      // $('.visualizar-galeria-modal .owl-stage').css({ lineHeight: height+'px', height: height+'px' });

      if ($('.visualizar-galeria-modal .formulario')[0])
        $('.visualizar-galeria-modal .formulario .content')
          .html($('.visualizar-sidebar .contato-wrapper').clone())
          .append($('.visualizar-sidebar .contato-label-info').clone())
    }
    $('.visualizar-galeria-modal').show()
  })

  $('.visualizar-galeria-modal .close').click(function (event) {
    $('.visualizar-galeria-modal').hide()
  })

  $('.btn-solicitar-endereco').click(function (event) {
    // if (ga) ga('send', 'event', 'SolicitarEndereco');

    $('.contato-wrapper .contato-form #mensagem').html(this.getAttribute('data-message')).parents('.campo-default').addClass('active')

    if ($(window).width() <= 780) $('.btn-show-contato').trigger('click')

    $('.contato-wrapper .contato-form #nome').focus()
  })
})

